import React, { useReducer } from 'react';
import pageReducer from './pageReducer';
import pageContext from './pageContext';

import {CURRENT_PAGE, CHANGE_PAGE} from 'types/context';

// Estado para indicar la pagina seleccionada y así mostrar el contenido
const PageState = props => {
    const initialState = {
        page: null
    }

    const [ state, dispatch ] = useReducer(pageReducer, initialState);

    // Funciones
    const paginaActual = () => {
        dispatch({
            type: CURRENT_PAGE,            
        });       
    }

    const cambiarPagina = (page) => { 
        console.log(page);       
        dispatch({
            type: CHANGE_PAGE,  
            payload: page          
        });       
    }
    


    return (
        <pageContext.Provider
            value={{
                page: state.page,
                paginaActual,
                cambiarPagina
            }}
        > 
            {props.children}
        </pageContext.Provider>
    )
}

export default PageState;